import React from "react";
import dayjs from "dayjs";
import { ReactSVG } from "react-svg";
import { getTransitIcons } from "../../../utils/images";
import "./LocationTrackTransit.scss";
import { default as isSameOrAfter } from "dayjs/plugin/isSameOrAfter";

dayjs.extend(isSameOrAfter)

const TransitPoint = ({ type, dateIn, dateOut, description, port }) => {
  const visited = (dateIn && dayjs().isSameOrAfter(dateIn)) || (dateOut && dayjs().isSameOrAfter(dateOut)) || false;

  return (
    <div className="TransitPoint">
      <div className="visited-circle" data-visited={visited}>
        <ReactSVG src={getTransitIcons(visited ? 'visited' : 'not-visited')} />
      </div>
      <div className="entry">
        <div className="entry__details">
          <div className="icon" data-visited={visited}>
            <ReactSVG src={getTransitIcons(type)} />
          </div>
          <div className="info">
            <div className="description">{description}</div>
            <div className="port">{port}</div>
          </div>
        </div>
        <div className="entry__dates">
          {
            dateIn && (
              <div className="item">
                <img src={getTransitIcons('date-in')} /><span>{dayjs(dateIn).format("DD MMM")}</span>
              </div>
            )
          }
          {
            dateOut && (
              <div className="item">
                <img src={getTransitIcons('date-out')} /><span>{dayjs(dateOut).format("DD MMM")}</span>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

const VesselPoint = ({ name }) => {
  return (
    <div className="VesselPoint">
      <div>
        <ReactSVG src={getTransitIcons('vessel')} />
      </div>
      <div>{name}</div>
    </div>
  )
}

const LocationTrackTransit = ({ shipment }) => {
  return (
    <div className="LocationTrackTransit">
      <VesselPoint name={shipment.vessel} />
      {/* Loading */}
      {shipment.loading_at && (<TransitPoint type={"pol"} dateOut={shipment.loading_at} description={"Origin Port Loading"} port={shipment.pol.full_name} />)}

      {/* Departure */}
      <TransitPoint type={"pol"} dateOut={shipment.pol.date} description={"Origin Port Departure"} port={shipment.pol.full_name} />

      {/* Transit */}
      {
        shipment.transits.map((transit, index) => {
          return <>
            <TransitPoint
              key={index}
              type={'transit'}
              description={'Transit Port'}
              port={transit.port}
              dateIn={transit.arrival_date}
              dateOut={transit.departure_date} />

            {transit.vessel && <VesselPoint name={transit.vessel} />}
          </>
        })
      }

      {/* Arrival */}
      <TransitPoint type={"pod"} dateIn={shipment.pod.date} description={"Destination Port Arrival"} port={shipment.pod.full_name} />

      {/* Discharge */}
      {shipment.discharge_at && (<TransitPoint type={"pod"} dateIn={shipment.discharge_at} description={"Destination Port Discharge"} port={shipment.pod.full_name} />)}

      {/* Gate Out */}
      {shipment.gated_out_at && (<TransitPoint type={"pod"} dateIn={shipment.gated_out_at} description={"Containers Gated Out"} port={shipment.pod.full_name} />)}

    </div>
  )
};

export default LocationTrackTransit;
